import ArtworkCard from './ArtworkCard';
import { GalleryItem } from '../data/gallery';

const ArtworkGrid = ({ artworks }: { artworks: GalleryItem[] }) => {
  return (
    <section className="artwork-grid" aria-live="polite">
      {artworks.map((artwork) => (
        <ArtworkCard key={artwork.id} artwork={artwork} />
      ))}
    </section>
  );
};

export default ArtworkGrid;
